import { useEffect, useState } from 'react';

/** Vrátí hodnotu se zpožděním, pro fulltext hledání bez zbytečných dotazů. */
export function useDebounce<T>(value: T, delay = 350): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
